export const GET_NEWS_LETTER = 'GET_NEWS_LETTER'
export const GET_NEWS_LETTER_SUCCESS = 'GET_NEWS_LETTER_SUCCESS'
export const GET_NEWS_LETTER_ERROR = 'GET_NEWS_LETTER_ERROR'
